import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount } from "vue";

import TheNavbar from "./components/TheNavbar.vue";
import TheNotification from "./components/TheNotification.vue";
import { apiClient } from "./plugins/api-client";
import { useVuetify } from "./plugins/vuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const vuetify = useVuetify();

onBeforeMount(async () => {
  vuetify.theme.dark = localStorage.getItem("elinor/theme") === "dark";
  await apiClient.authentication.getCsrfToken();
});

return { __sfc: true,vuetify, TheNavbar, TheNotification }
}

})